import React from 'react';
import { component } from './styles.module.scss';

const Loader = (props) => {
  return (
    <div
      className={component}
      style={{ height: props.height, lineHeight: `${props.height}px` }}
    >
      <div className='ring-loader'><div /><div /><div /><div /></div>
    </div>
  );
};

export default Loader;
